import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueLazyload from 'vue-lazyload';
import axiosLogger from "./utils/axiosLogger";
import errorImg from './assets/img/error.png';
import loadingImg from './assets/img/loading.gif'; 
import vue3ToPdf from 'vue3-to-pdf'

import "./assets/scss/argon-dashboard.scss";

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(VueAxios, axios);
appInstance.use(VueLazyload, {
    preLoad: 1.3,
    error: errorImg,
    loading: loadingImg,
    attempt: 1,
    observer: true,
    // optional
    observerOptions: {
      rootMargin: '0px',
      threshold: 0.1
    }
  });
appInstance.use(vue3ToPdf)
appInstance.use(require('vue-cookies'));
appInstance.use(axiosLogger);
appInstance.config.errorHandler = (err, vm, info) => {
  console.error("Error:", err);
  console.error("Vue component:", vm);
  console.error("Additional info:", info);
  
};
appInstance.mount("#app");
